module.exports = __webpack_public_path__ + "img/011-zimbabwe.1e5f7ac6.svg";